<template>
  <div class="SoftwareHome">
    <div class="soft_top">
      <div class="soft_main">
        <div class="top_item" v-for="item in list">
          <div class="item_top" @click="go(item)">
            <img :src="item.src" alt="">
          </div>
          <div class="item_btm font_shadow" v-for="info in item.info">
            {{info}}
          </div>
        </div>
      </div>
    </div>
    <div class="software">
      <div class="software_main flex_row">
        <div class="soft_left flex_row">
          <div class="soft_synopsis">
            <div class="pc">智慧视光PC版</div>
            <div class="experience">全新出发 专业体验</div>
            <div class="downloadBtn"><button  @click="downloadClick" class="flex_row">立即下载 <span></span> </button></div>
            <div class="operation">适用于Windows10或以上操作系统</div>
          </div>
        </div>
        <div class="flex_row soft_right">
          <img src="@/assets/img/software.png" alt="">
        </div>
      </div>
      <img class="back" src="@/assets/img/softwareBackground.jpg" alt="">
    </div>
    <div class="softMain">
      <div class="font_shadow softMain_top">智慧眼健康中心运营体系建设</div>
      <img src="@/assets/img/software_main.png" alt="">
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import bottom from "@/components/pc/bottom";
export default {
  name: 'SoftwareHome',
  components: {
    bottom
  },
  data() {
    return {
      list: [],
    }
  },
  created() {
    let list = [
      {
        proId: 0,
        src: 'http://2022.visumall.com/public/img/software_1.png',
        info: ['眼科/视光', 'HIS系统']
      },
      {
        proId: 1,
        src: 'http://2022.visumall.com/public/img/software_2.png',
        info: ['智能营销', 'SCRM']
      },
      {
        proId: 2,
        src: 'http://2022.visumall.com/public/img/software_3.png',
        info: ['电子病历', 'EHR']
      },
      {
        proId: 3,
        src: 'http://2022.visumall.com/public/img/software_4.png',
        info: ['AI辅助诊断', '人工智能处方']
      },
      {
        proId: 4,
        src: 'http://2022.visumall.com/public/img/software_5.png',
        info: ['ERP', '系统']
      },
      {
        proId: 5,
        src: 'http://2022.visumall.com/public/img/software_6.png',
        info: ['远程手术', '诊疗系统']
      },
      {
        proId: 6,
        src: 'http://2022.visumall.com/public/img/software_7.png',
        info: ['无人值守', 'AI验配系统']
      },
      {
        proId: 7,
        src: 'http://2022.visumall.com/public/img/software_8.png',
        info: ['校医联盟', '近视防控系统']
      },
      {
        proId: 8,
        src: 'http://2022.visumall.com/public/img/software_9.png',
        info: ['运营大数据', '智能报告系统']
      },
      {
        proId: 9,
        src: 'http://2022.visumall.com/public/img/software_10.png',
        info: ['24小时呵护', '云诊视系统']
      },
    ];
    this.list = list
  },
  methods: {
    go(item) {
      this.$store.commit('setProId', item.proId);
      this.$router.push({path: '/SoftWareYM'});
    },
    downloadClick() {
      console.log('downloadClick')
      if(this.$store.state.bases.ApplyId || this.$store.state.bases.ApplyTel) {
        this.$router.push({path: '/ViewAudit'});
      }
      else {
        this.$router.push({
          path: '/Register',
          query: {
            item: -1
          }
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.SoftwareHome {
  .soft_top {
    background: url("http://2022.visumall.com/public/img/softHomeMain.jpg") no-repeat;
    background-size: 100% auto;
    width: 100vw;
    min-width: 1024px;
    padding-top: 0.6rem;
    .soft_main {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      .top_item {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 0.3rem;
        transition: all 0.2s;
        cursor: pointer;
        &:hover {
          transform: scale(1.06);
        }
        .item_top {
          img {
            width: 68%;
            //margin-bottom: 18px;
            //transition: all 0.2s;
          }
        }
        .item_btm {
          font-size: 0.16rem;
        }
      }
    }
  }

  .software {
    position: relative;
    .back {
      width: 100%;
      opacity: 0.3;
    }
    .software_main {
      z-index: 1;
      position: absolute;
      height: 100%;
      width: 100%;
      .soft_left {
        flex: 1;
        .soft_synopsis {
          width: 60%;
          display: flex;
          flex-direction: column;
          justify-content: left;
          align-items: flex-start;
          .pc {
            font-size: 0.18rem;
            margin-bottom: 0.1rem;
            color: #2E2E2E;
          }
          .experience {
            font-size: 0.26rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
          }
          .downloadBtn {
            margin-bottom: 0.17rem;
            button {
              display: flex;
              padding: 0.12rem 0.1rem 0.12rem;
              border-radius: 0.04rem;
              font-size: 0.15rem;
              background: #00A0E9;
              color: #FDFDFD;
              border: none;
              span {
                display: inline-block;
                margin-left: 0.15rem;
                width: 0;
                height: 0;
                border: 0.1rem solid #FDFDFD;
                border-top-color: transparent;
                border-bottom-color: transparent;
                border-left-color: #FDFDFD;
                border-right-color: transparent;
              }
            }
          }
          .operation {
            font-size: 0.13rem;
            color: #2E2E2E;
          }
        }
      }
      .soft_right {
        flex: 1;
        justify-content: flex-start;
        img {
          width: 80%;
        }
      }
    }
  }

  .softMain {
    .softMain_top {
      margin: 0.55rem auto 0.4rem;
    }
    img {
      width: 100%;
      margin-bottom: 1.5rem;
    }
  }


}
</style>
